"use strict";
// (C) 2019 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewByAttributesLimit = void 0;
/**
 * Maximum number of attributes for view-by slicing.
 *
 * @public
 */
exports.ViewByAttributesLimit = 2;
//# sourceMappingURL=limits.js.map